import React from 'react';
import { FeatureMyRankView } from './FeatureMyRank.view';
import { BOARD_NAME } from '../../../../types/leaderboard/leaderboard';
import { Rank } from '../../../../types/classe/classeRank';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import FrontError from 'helpers/errors/front.error';
import { useQuery } from '@apollo/client';
import { GetPositionsQuery } from 'graphql/generated/graphql';
import { GET_POSITIONS } from 'graphql/query/leaderBoard/leaders.query';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';

export interface MyRank {
  rank: Rank;
  name: BOARD_NAME;
}

interface FeatureMyRankProps {
  showAcademie?: boolean;
}

export const FeatureMyRank = ({ showAcademie = true }: FeatureMyRankProps) => {
  const { loading, data, error } = useQuery<GetPositionsQuery>(GET_POSITIONS);

  if (loading) return <LoadingContainer variant="MyRank" />;
  if (error)
    return (
      <ErrorContainer
        text={
          'Informations de classe non valide, veuillez recharger la page ou vous déconnecter puis reconnecter'
        }
        setFeedback
        detailErr={
          new FrontError('Dashboard, erreur récupération eleve', error)
        }
        needCaptureError={false}
      />
    );
  const positions = data.myPositions;
  const ranks: MyRank[] = [
    {
      rank: positions.classeRank,
      name: BOARD_NAME.classe
    },
    {
      rank: positions.niveauRank,
      name: BOARD_NAME.niveau
    },
    {
      rank: positions.academieRank,
      name: BOARD_NAME.academie
    },
    {
      rank: positions.nationalRank,
      name: BOARD_NAME.national
    }
  ];

  !showAcademie && ranks.splice(2, 1);

  return <FeatureMyRankView ranks={ranks} />;
};
